import { render, staticRenderFns } from "./topicDetailChecks.vue?vue&type=template&id=56cc0af0&scoped=true&"
import script from "./topicDetailChecks.vue?vue&type=script&lang=js&"
export * from "./topicDetailChecks.vue?vue&type=script&lang=js&"
import style0 from "./topicDetailChecks.vue?vue&type=style&index=0&id=56cc0af0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc0af0",
  null
  
)

export default component.exports